import Vue from 'vue';
import Component from 'vue-class-component';

import ExperiencePreview from 'components/ExperiencePreview';
import NewActivityBlock from 'common/components/NewActivityBlock';
import HeartIt from 'common/components/HeartIt';
import Rating from 'common/components/Rating';
import getLastTld from 'common/services/utils/getLastTld';

@Component({
  components: {
    HeartIt,
    Rating,
    ExperiencePreview,
    NewActivityBlock,
    DiscountLabel: () => import('common/components/DiscountLabel'),
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    isFriendsDay: {
      type: Boolean,
      default: false,
    },
    removePreview: {
      type: Boolean,
      default: false,
      description:
        'Cancels the preview of the Experience and goes directly yo the Experience page when clicked',
    },
    position: {
      type: Number,
    },
    positionSelected: {
      type: Number,
    },
    experiencePreviewBoxBoolean: {
      type: Boolean,
    },
    experiencePreviewBoxStartingTab: {
      type: String,
      default: 'Summary',
    },
    boxName: {
      type: String,
    },
    boxId: {
      type: String,
    },
    boxColour: {
      type: String,
    },
    boxCategoryID: {
      type: String,
    },
    campaignColor: {
      type: String,
      required: false,
    },
    campaignSlug: {
      type: String,
      required: false,
    },
    landingSlug: {
      type: String,
      required: false,
    },
    toWho: {
      type: String,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    goToExperienceTab: {
      type: Boolean,
      default: false,
    },
    gift: {
      type: Object,
      required: false,
    },
    showOnlineReservationLabel: {
      type: Boolean,
      required: false,
    },
    booked: {
      type: Boolean,
      default: false
    }
  },
})
export default class ExperienceBoxComponent extends Vue {
  firstActivityMediaType = '';
  windowWidth = null;
  threeColumnsBreakpoint = 1160;
  twoColumnsBreakpoint = 768;
  oneColumnBreakpoint = 480;

  mounted() {
    const boxActivity = this.activity.activity;
    if (
      this.activity &&
      boxActivity.images.length > 0 &&
      boxActivity.images[0]?.image?.slice(-3) === 'mp4'
    ) {
      this.firstActivityMediaType = 'video';
    } else {
      this.firstActivityMediaType = 'image';
    }
  }

  updated() {
    this.toggleShowPurchaseDetailButton(this.experiencePreviewBoxBoolean);
  }

  /**
   * Issue an event to the parent 'BaseBoxView'
   */
  changePosition(showPreview) {
    this.$emit('changePositionSelected', {
      newPosition: this.position,
      showPreview,
      experienceElement: this.$el,
    });
  }

  created() {
    this.recalculateWidth();
    window.addEventListener('resize', this.recalculateWidth);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.recalculateWidth);
  }

  recalculateWidth() {
    this.windowWidth = window.innerWidth;
  }

  experienceImage() {
    if (this.activity.activity.images[0].image.slice(-3) === 'mp4') {
      return 'video';
    }
    return 'image';
  }
  /**
   * Determine what to do when the experience is clicked:
   * If the prop 'removePreview' is true, the the user will be redirected to the experience url
   * If not, the experience preview will be displayed
   * @param {String} url
   */
  clickHandler(url) {
    if (this.removePreview) {
      if (this.campaignSlug) {
        url += `?campaignSlug=${this.campaignSlug}`;
      } else if (this.landingSlug) {
        url += `?landingSlug=${this.landingSlug}`;
      }
      this.$router.push(url);
    } else {
      this.seeExperiencePreview();
    }
  }

  /**
   * 'experiencePreviewBoxBoolean' is a prop that comes from the parent 'BaseBoxView' that lets me know if
   * the Preview with the Experience should or should not be displayed and also calls the function
   * 'changePosition' that emits an event to the parent component 'BaseBoxView' with two parameters,
   * the new position and a Boolean to know if the experiencePreview should be hidden
   */
  seeExperiencePreview() {
    if (this.activity.activity.activity_type === 'closed') {
      return;
    }
    if (!this.experiencePreviewBoxBoolean) {
      this.changePosition(true);
    } else {
      this.changePosition(false);
    }
  }

  /**
   * experienceBoxClass returns a class to align the boxes, adding a margin-right in case the class is
   * 'experienceBox1' or 'experienceBox2' and another class to align the previews allowing to modify
   * the left parameter of that element since its position is absolute at container, that is, the box
   */
  experienceBoxClass(elementPosition, type) {
    let position;

    if (this.windowWidth <= this.twoColumnsBreakpoint) {
      position = (elementPosition % 2) + 1;
    } else {
      position = (elementPosition % 3) + 1;
    }
    return type === 'box'
      ? `experienceBox${position}`
      : `experiencePreview${position}`;
  }

  closePreview() {
    this.changePosition(false);
  }

  get experienceLocation() {
    const { activity } = this.activity;
    let experienceType = '';

    if (activity.locations[0].delivery_in_all_country) {
      experienceType = 'Envío a todo el país';
    } else if (activity.activity_type === 'online') {
      experienceType = 'Formato online';
    } else {
      experienceType = `${activity.locations[0].sublocation} - ${activity.locations[0].address}`;
    }

    return experienceType;
  }

  get tagBoxColor() {
    return `background-color: ${this.boxColour};`;
  }

  get country() {
    return getLastTld();
  }

  toggleShowPurchaseDetailButton(val) {
    // if is mobile resolution and showPreviewModal is open we hide the PurchaseDetailButton but when is closed we show it again
    if (this.windowWidth > 768) return;
    this.$store.showPurchaseDetailButton = !val;
  }
}
